import React from 'react';
import { Outlet } from 'react-router-dom';
import Auth from 'containers/Auth';
import { AuthenticatedView } from 'containers/ReportsOverview/AuthenticatedView';
import { useHideChat } from '../../components/Reports/CandidateLandingPage/chatVisibility';

const Verifications: React.FC = () => {
  // Hide the chat launcher across the verification flow so it cannot
  // overlay the mobile upload/submit button on small viewports (ECDEX-2707).
  useHideChat();

  return (
    <Auth isVerification>
      <AuthenticatedView>
        <Outlet />
      </AuthenticatedView>
    </Auth>
  );
};

export default Verifications;
